import { Component, OnDestroy, OnInit } from "@angular/core";
import { getMetricsState } from "../../store/appState";
import { Store } from "@ngrx/store";
import {
  metric,
  metricsState,
  MetricVisibilities,
} from "../../store/metrics/state";
import { ActivatedRoute } from "@angular/router";
import {
  GetMetricsAction,
  ResetSavedSuccessMessageAction,
  UpdateMetricVisibilityAction,
} from "../../store/metrics/actions";
import {
  find,
  forEach,
  map,
  sortBy,
  uniq,
  filter,
  isEqual,
  cloneDeep,
} from "lodash";
import { KpiService } from "../../kpi/kpi.service";
import { school } from "../../store/schools/state";
import { Subscription } from "rxjs";
import { DistrictSchools } from "../../shared/interfaces";

@Component({
  selector: "visibility-settings",
  templateUrl: "./visibility-settings.component.html",
  styleUrls: ["./visibility-settings.component.scss"],
})
export class VisibilitySettingsComponent implements OnInit, OnDestroy {
  metricsState: metricsState;
  metrics: Array<metric>;
  kpiId: string;
  schools: Array<school>;
  updatedMetrics: Array<metric>;
  metricsStateSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private store: Store<any>,
    private kpiService: KpiService
  ) {}

  ngOnInit() {
    this.kpiService.getDistrictSchools().subscribe(
      (data: DistrictSchools) => {
        this.schools = data.schools;
      },
      (error) => {
        console.error(error);
      }
    );
    this.kpiId = this.route.snapshot.paramMap.get("metricId");
    this.store.dispatch(new GetMetricsAction(this.kpiId));
    this.metricsStateSub = this.store
      .select(getMetricsState)
      .subscribe((metricsState) => {
        this.metricsState = metricsState;
        if (this.metricsState) {
          if (!isEqual(this.metricsState.allMetrics, this.metrics)) {
            // new metrics
            this.metrics = this.metricsState.allMetrics;
            this.updatedMetrics = cloneDeep(this.metrics);
          }
          if (
            this.metricsState.savedSuccessfully &&
            this.metricsState.savedSuccessfully["metricVisibility"]
          ) {
            setTimeout(() => {
              this.store.dispatch(
                new ResetSavedSuccessMessageAction("metricVisibility")
              );
            }, 5000);
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.metricsStateSub.unsubscribe();
  }

  save() {
    // loop through list of metrics and pull out fields in format
    /*
      Integer kpiId
      Boolean visible
      List<String> systemSchoolIds
     */
    let body: Array<MetricVisibilities> = map(this.updatedMetrics, (metric) => {
      return {
        kpiId: metric.kpi_id,
        visible: metric.visible,
        systemSchoolIds: metric.systemSchoolIds,
      };
    });
    this.store.dispatch(new UpdateMetricVisibilityAction(body));
  }
}
